import {
    FAV_ICON_UPLOAD_ERROR,
    FAV_ICON_UPLOAD_START,
    FAV_ICON_UPLOAD_SUCCESS
} from '../../constants/index';
import { updateSiteSettingsMutation as mutation } from '../../lib/graphql';

export const updateFavIcon = (fileName) => {

    return async (dispatch, getState, { client }) => {

        try {

            dispatch({
                type: FAV_ICON_UPLOAD_START
            })
            const { data } = await client.mutate({
                mutation,
                variables: {
                    favicon: fileName
                }
            })

            dispatch({
                type: data?.updateSiteSettings?.status === 200 ? FAV_ICON_UPLOAD_SUCCESS : FAV_ICON_UPLOAD_ERROR
            });

        } catch (err) {
            dispatch({
                type: FAV_ICON_UPLOAD_ERROR
            })
        }
    }
}